export const START_LOAD_OCM_ACTION = 'ocm/start/load';

export type OCMPayload = {
  currentConsumptionAmount: number;
  minimalAmount: number;
  lastConsumptionAlertedDate: Date | null;
};
export type OCMTypes = {
  data: OCMPayload;
  isLoading: boolean;
  firstLoad: boolean;
  error: Error | null;
  outOfSold: boolean;
  warningSold: boolean;
};

export type StartLoadOCMAction = {
  type: typeof START_LOAD_OCM_ACTION;
};

export type UpdateOcmPayload = {
  data: OCMPayload;
};

export type UpdateOcmError = {
  error: Error | null;
};

export type UpdateOcmIsLoading = {
  isLoading: boolean;
};

export type UpdateOcmFirstLoad = {
  firstLoad: boolean;
};
